import ScreenSizeAddScreen from './ScreenSizeAddScreen';

export default ScreenSizeAddScreen;
